import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { beforeItems, afterItems } from "../../data/content";
export function Transformation() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" aria-label="The transformation" data-id="element-294" data-mp="1nrll6rtuu7qu">
      <div className="mx-auto max-w-5xl" data-id="element-295" data-mp="1is91uh26zit0">
        <SectionHeading title={<>The <em className="text-gold" data-id="element-297" data-mp="2ffdmub418gdy">transformation</em></>} data-id="element-296" data-mp="2fh6v1uuan8o2" />

        <div className="grid gap-5 md:grid-cols-2" data-id="element-298" data-mp="2bfbwgy3qz9dz">
          <div className="rounded-3xl bg-white p-6 ring-2 ring-alert/30 sm:p-8" data-id="element-299" data-mp="2bfljccthx0fg">
            <h3 className="mb-5 flex items-center gap-3 font-serif text-2xl font-bold text-alert" data-id="element-300" data-mp="26n29nqxxipfx">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-alert text-white" data-id="element-301" data-mp="21oh73kv7ftob">
                <XIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-302" data-mp="2z67itfpfpcdu" />
              </span>
              Before
            </h3>
            <ul className="space-y-3" data-id="element-303" data-mp="1586eo1wl3tcl">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-base leading-relaxed text-ink/80" data-id="element-304" data-mp="15a9ch83zaqrv">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-alert" strokeWidth={3} aria-hidden="true" data-id="element-305" data-mp="1a93tc4idy59c" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 shadow-xl ring-2 ring-cta sm:p-8" data-id="element-306" data-mp="10f3jxqg2mdut">
            <h3 className="mb-5 flex items-center gap-3 font-serif text-2xl font-bold text-white" data-id="element-307" data-mp="mjrnnem9ofbs">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-cta text-white" data-id="element-308" data-mp="reotkco928kg">
                <CheckIcon className="h-5 w-5" strokeWidth={3} aria-hidden="true" data-id="element-309" data-mp="djd0e9pqsq5n" />
              </span>
              After
            </h3>
            <ul className="space-y-3" data-id="element-310" data-mp="27urqwsqkutmg">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-base font-medium leading-relaxed text-white" data-id="element-311" data-mp="2bwd3ecz795w4">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-312" data-mp="3kttkx1dl53yg" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-muted" data-id="element-313" data-mp="3btoeatg7u9lc">
          The goal isn't to replace clinical judgment, formal training or mentorship. It's to give you a structured environment for practicing educational case analysis.
        </p>

        <CtaButton label="I want to make this change" className="mt-8" data-id="element-314" data-mp="3ctlk6t4u5kz" />
      </div>
    </section>;
}